import { render } from "./betDetail.vue?vue&type=template&id=9d0d9e94&scoped=true"
import script from "./betDetail.vue?vue&type=script&lang=js"
export * from "./betDetail.vue?vue&type=script&lang=js"

import "./betDetail.vue?vue&type=style&index=0&id=9d0d9e94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d0d9e94"]])

export default __exports__